export function findReference(
  listFavServices,
  listReminder,
  numReference,
  dataConfigInputs
) {
  // Determinar cuál lista usar
  const listReference = listFavServices || listReminder;
  // Si ambas son undefined, no hay nada que validar
  if (!listReference) return false;
  // Normalizar la referencia (eliminar espacios)
  const normalizedRef = numReference.replace(/\s+/g, "");
  // Validar que no exista en la lista seleccionada
  const isNotSavedInFavorites = !listReference.some(
    (ref) => ref.accountService === normalizedRef
  );
  //busca el input de referencia
  const referenceInput = dataConfigInputs.find(
    (input) => input.id === "destAccountId"
  );
  //Validar longitud con regex (si existe en configuración)
  let isValidLength = true;
  if (referenceInput && referenceInput.maxValueLengthOCRAllowedRegExp) {
    console.log(
      referenceInput.maxValueLengthOCRAllowedRegExp,
      "maxValueLengthOCRAllowedRegExp"
    );
    try {
      const regex = new RegExp(referenceInput.maxValueLengthOCRAllowedRegExp);
      isValidLength = regex.test(normalizedRef);
    } catch (error) {
      console.error("Regex inválida en configuración:", error);
      isValidLength = false;
    }
  }
  console.log(isValidLength, "isValidLength Reference to favorites");
  return isNotSavedInFavorites && isValidLength;
}
